<template>
  <div class="gatewayError">
    <div class="message">
      <div class="desc">{{ retryMsg }}</div>
      <div class="buttons">
        <div class="btn1" @click="doNewOrder" v-if="newOrderShow">{{ $t('lang.account.newOrder') }}</div>
        <div class="btn2" @click="handleClose">{{ $t('lang.inviteFriends.close') }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'GatewayError',
  props: ['handleClose', 'doNewOrder', 'newOrderShow', 'retryMsg'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.gatewayError {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000;

  .message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 86.666vw;
    height: max-content;
    background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%);
    border: 0.3vw solid #737373;
    border-radius: 4.166vw;

    .desc {
      width: 75.833vw;
      margin: 13.888vw auto;
      text-align: center;
      font-size: 4.722vw;
      font-weight: 400;
      letter-spacing: -0.05em;
      color: #C4C4C4;
    }

    .center {
      margin: -7.5vw auto 0 auto;
      width: 51.388vw;
      height: 40vw;
      overflow: hidden;
      display: flex;
      align-items: flex-start;

      img {
        width: 51.388vw;
        height: 48.0555vw;
      }
    }

    .buttons {
      margin: 0 auto 7.5vw auto;
      width: 65.883vw;
      height: max-content;
      text-align: center;
      line-height: 10vw;
      text-transform: capitalize;
      font-size: 4.166vw;
      font-weight: 600;

      .btn1 {
        width: 65.883vw;
        border-radius: 1.388vw;
        height: 10vw;
        background: linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
        color: #000000;
      }

      .btn2 {
        margin-top: 3.333vw;
        width: 65.883vw;
        border-radius: 1.388vw;
        height: 10vw;
        border: 0.3vw solid #E2C28F;
        color: #E1C18D;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GatewayError/index.vue